import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import MenuListItemTspPq from '@components/ListItem/MenuListItemTsoPq';
import { Box, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeasuringDeviceType from './MeasuringDevice/MeasuringDevice';
import TransducerModel from './Transducer/Transducer';
import VoltageLevel from './VoltageLevel/Voltage';

const StyledManagementPage = styled(Box)(() => {
  return {
    height: '100vh',
    display: 'grid',
    gridTemplateColumns: '25rem auto',
  };
});

const StyledManagementMenu = styled(Box)(() => {
  return {
    height: '100%',
    backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
    borderRight: `1px solid ${tsoPqTheme.palette.stroke.color_primary_stroke_str_prim_accent}`,
  };
});

const StyledManagementMenuHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: `4.625rem`,
  };
});

const StyledHeaderTitle = styled(Box)(() => {
  return {
    fontWeight: '500',
    fontFamily: tsoPqTheme.typography.openSans,
    lineHeight: tsoPqTheme.typography.lineHeight_m,
    fontSize: tsoPqTheme.typography.fontsize_title_list_section_small,
    padding: `0rem ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_com_padding_s}`,
    marginBottom: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_com_gap_m,
  };
});

const MasterdataManagementPage = () => {
  const { t } = useTranslation();

  const [selectedItem, setSelectedItem] = useState<string>('transducer');

  const renderContent = () => {
    switch (selectedItem) {
      case 'transducer':
        return <TransducerModel />;
      case 'voltageLevel':
        return <VoltageLevel />;
      case 'measuringDeviceType':
        return <MeasuringDeviceType />;
      default:
        return 'transducer';
    }
  };
  return (
    <StyledManagementPage>
      <StyledManagementMenu>
        <StyledManagementMenuHeader>
          <StyledHeaderTitle>{t('masterdata.management')}</StyledHeaderTitle>
          <MenuListItemTspPq
            label={t('masterdata.transducer.section')}
            active={selectedItem === 'transducer'}
            onClick={() => {
              setSelectedItem('transducer');
            }}
          />
          <MenuListItemTspPq
            label={t('masterdata.voltageLevel.section')}
            active={selectedItem === 'voltageLevel'}
            onClick={() => {
              setSelectedItem('voltageLevel');
            }}
          />
          <MenuListItemTspPq
            label={t('masterdata.measuringDeviceType.section')}
            active={selectedItem === 'measuringDeviceType'}
            onClick={() => {
              setSelectedItem('measuringDeviceType');
            }}
          />
        </StyledManagementMenuHeader>
      </StyledManagementMenu>
      {renderContent()}
    </StyledManagementPage>
  );
};

export default MasterdataManagementPage;
